// extracted by mini-css-extract-plugin
export default {"container":"ProjectHelpPage3_container__bjmNk","text":"ProjectHelpPage3_text__Y6FRJ","example":"ProjectHelpPage3_example__+EvCL","button":"ProjectHelpPage3_button__pAyDh"};